export default function testimonialWidget(editor) {
  editor.DomComponents.addType('eb-testimonial', {
    isComponent(el) {
      return el.getAttribute && el.getAttribute('data-gjs-type') === 'eb-testimonial'
    },
    model: {
      defaults: {
        name: 'Testimonial',
        tagName: 'div',
        droppable: false,
        attributes: { 'data-gjs-type': 'eb-testimonial' },
        style: {
          'text-align': 'center',
          'padding': '40px 30px',
          'max-width': '600px',
          'margin': '0 auto',
        },
        components: `
          <img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MCIgaGVpZ2h0PSI4MCIgdmlld0JveD0iMCAwIDgwIDgwIj48cmVjdCB3aWR0aD0iODAiIGhlaWdodD0iODAiIGZpbGw9IiNlMGUwZTAiIHJ4PSI0MCIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBkb21pbmFudC1iYXNlbGluZT0ibWlkZGxlIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMTIiIGZpbGw9IiM5OTkiPkF2YXRhcjwvdGV4dD48L3N2Zz4=" alt="Avatar" style="width:80px;height:80px;border-radius:50%;object-fit:cover;margin-bottom:20px;" />
          <p style="font-size:16px;color:#555;line-height:1.7;font-style:italic;margin:0 0 20px;">"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo."</p>
          <h4 style="font-size:18px;font-weight:600;color:#333;margin:0 0 4px;">John Doe</h4>
          <p style="font-size:13px;color:#999;margin:0;">CEO, Company Name</p>
          <div style="margin-top:12px;color:#f5a623;font-size:16px;">
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
          </div>
        `,
        traits: [
          { type: 'text', name: 'data-avatar-url', label: 'Avatar URL' },
          { type: 'select', name: 'data-rating', label: 'Star Rating', options: [
            { id: '5', label: '5 Stars' },
            { id: '4', label: '4 Stars' },
            { id: '3', label: '3 Stars' },
            { id: '0', label: 'No Stars' },
          ]},
        ],
      },
    },
  })

  editor.BlockManager.add('eb-testimonial', {
    label: 'Testimonial',
    category: 'General',
    media: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M9,22A1,1 0 0,1 8,21V18H4A2,2 0 0,1 2,16V4C2,2.89 2.9,2 4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M5,5V7H19V5H5M5,9V11H13V9H5M5,13V15H15V13H5Z"/></svg>',
    content: { type: 'eb-testimonial' },
  })
}
